"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAirdropShare = getAirdropShare;
async function getAirdropShare(address) {
    const airdropReserve = "123";
    console.log(address);
    return airdropReserve;
}
//# sourceMappingURL=getAirdropShare.js.map